import * as React from 'react';
import { PiralDocsFooterComponentProps } from '../scripts/types';

const Footer: React.FC<PiralDocsFooterComponentProps> = ({ children }) => <>{children}</>;

export default Footer;
